<a class="navigation-link" *ngIf="item.url" [routerLink]="item.url" routerLinkActive="active" [routerLinkActiveOptions]="{exact: false}" matRipple>
  <mat-icon class="navigation-link-icon" *ngIf="item.icon">{{item.icon}}</mat-icon>
  <span class="navigation-link-title">{{item.title}}</span>
  <span class="navigation-link-badge" *ngIf="item.badge" [ngStyle]="{'background-color': item.badge.bg, 'color': item.badge.fg}">{{item.badge.title}}</span>
</a>
